// @flow

export type DidIt = {
  type: 'PIN_DID_IT',
  payload: {
    id: string,
    value: boolean,
  },
};

export function pinDidIt(id: string): DidIt {
  return {
    type: 'PIN_DID_IT',
    payload: {
      id,
      value: true,
    },
  };
}

export function pinUnDidIt(id: string): DidIt {
  return {
    type: 'PIN_DID_IT',
    payload: {
      id,
      value: false,
    },
  };
}
